module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'ge77gn82',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
